"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _configuratorCarousel = require("@mmc/configurator-carousel");
var _configuratorAccessoriesSelector = require("@mmc/configurator-accessories-selector");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _actions = require("../actions");
var _disclaimer = _interopRequireDefault(require("./disclaimer/disclaimer"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray;
var AccessoriesSelector = /*#__PURE__*/function (_React$Component) {
  function AccessoriesSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.changeEvent = _this.changeEvent.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(AccessoriesSelector, _React$Component);
  var _proto = AccessoriesSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var dispatch = this.props.dispatch;
    var validAccessories = this.getValidAccessories();
    dispatch((0, _actions.setAccessories)(validAccessories));
  };
  _proto.getValidAccessories = function getValidAccessories() {
    var _this2 = this;
    var _this$props = this.props,
      data = _this$props.data,
      dispatch = _this$props.dispatch,
      preferences = _this$props.preferences,
      _this$props$accessori = _this$props.accessories,
      accessories = _this$props$accessori === void 0 ? [] : _this$props$accessori;
    var preferredAccessories = preferences.accessories || [];
    var allAccessoriesObject = data.filterAllAccessories || [];
    var accessoryCategories = [];
    if (allAccessoriesObject[0]) {
      accessoryCategories = allAccessoriesObject[0].filters;
    }
    var validAccessories = [];
    var selectedAccessories = accessories.concat(preferredAccessories);
    var forcedOptionCodes = data.forcedOptionCodes;
    if (accessoryCategories[0]) {
      accessoryCategories.forEach(function (currentCategory) {
        currentCategory.filteringOptions.forEach(function (currentAccessory) {
          if (selectedAccessories.includes(currentAccessory.code) || forcedOptionCodes.includes(currentAccessory.code)) {
            validAccessories.push(currentAccessory.code);

            // When the forced selected accessory has notCompatibleOptions, this adds those codes as default greyed-out accessories. Users cannot select those accessories.
            if (currentAccessory.notCompatibleOptions) {
              var incompatibleCodes = _this2.props.incompatibleCodes;
              var nextState = [].concat(incompatibleCodes, currentAccessory.notCompatibleOptions);
              dispatch((0, _actions.setIncompatibleCodes)(nextState));
            }
          }
        });
      });
    }
    return validAccessories;
  };
  _proto.changeEvent = function changeEvent(e) {
    var _this$props2 = this.props,
      data = _this$props2.data,
      dispatch = _this$props2.dispatch,
      accessories = _this$props2.accessories;
    var updatedAccessories = accessories.slice();
    var selectedAccessory = e.target.value;
    var selectedAccessoryIndex = accessories.indexOf(selectedAccessory);
    var accessoriesList = [];
    data.filterAllAccessories[0].filters.forEach(function (f) {
      accessoriesList.push.apply(accessoriesList, f.filteringOptions);
    });
    var selectedAccessoriesObj = accessoriesList.find(function (a) {
      return a.code === selectedAccessory;
    });
    var options = selectedAccessoriesObj.notCompatibleOptions ? selectedAccessoriesObj.notCompatibleOptions : [];
    // Toggle the accessory in our array
    if (selectedAccessoryIndex === -1) {
      updatedAccessories.push(selectedAccessory);
      if (selectedAccessoriesObj) {
        var incompatibleCodes = this.props.incompatibleCodes;
        var nextState = [].concat(incompatibleCodes, options);
        dispatch((0, _actions.setIncompatibleCodes)(nextState));

        // This is needed when if there is already checked accessories, but when it has to be unselected due to compatibility
        updatedAccessories = updatedAccessories.filter(function (code1) {
          return !options.some(function (code2) {
            return code1 === code2;
          });
        });
      }
    } else {
      updatedAccessories.splice(selectedAccessoryIndex, 1);
      if (selectedAccessoriesObj) {
        var _incompatibleCodes = this.props.incompatibleCodes;
        var _nextState = _incompatibleCodes.filter(function (code1) {
          return !options.some(function (code2) {
            return code1 === code2;
          });
        });
        dispatch((0, _actions.setIncompatibleCodes)(_nextState));
      }
    }

    // Update Redux
    dispatch((0, _actions.setAccessories)(updatedAccessories));
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      accessories = _this$props3.accessories,
      incompatibleCodes = _this$props3.incompatibleCodes,
      minorQueryPending = _this$props3.minorQueryPending,
      market = _this$props3.market,
      _this$props3$theme = _this$props3.theme,
      theme = _this$props3$theme === void 0 ? {} : _this$props3$theme,
      data = _this$props3.data,
      disclaimerData = _this$props3.disclaimerData;
    var filterRecommendedAccessories = data.filterRecommendedAccessories,
      filterAllAccessories = data.filterAllAccessories,
      headingText = data.headingText,
      forcedOptionCodes = data.forcedOptionCodes,
      accessoriesPriceDisclaimerId = data.priceDisclaimerId;
    var carousel = data.carousel || {};
    var AccessoriesSelectorData = {
      filterRecommendedAccessories: filterRecommendedAccessories,
      filterAllAccessories: filterAllAccessories,
      headingText: headingText,
      forcedOptionCodes: forcedOptionCodes
    };
    var direction = this.props.direction;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].stepContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configurator["default"].loaderWrapper
    }, !isEmptyArray(carousel.items) && /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
      theme: theme,
      data: carousel,
      isLoading: minorQueryPending > 0
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme.marginBottom80,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement(_configuratorAccessoriesSelector.ConfiguratorAccessoriesSelector, {
      theme: theme,
      data: AccessoriesSelectorData,
      changeEvent: this.changeEvent,
      selectedAccessories: accessories,
      forcedOptionCodes: forcedOptionCodes,
      notCompatibleOptionCodes: incompatibleCodes,
      disclaimerData: disclaimerData,
      accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
    }), data.disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer
    }, data.disclaimer))), data.disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-md-offset-1'] + " " + theme['col-md-10']
    }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
      theme: theme,
      headline: "Disclaimer",
      content: data.disclaimer
    }))));
  };
  return AccessoriesSelector;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    accessories: state.accessories.value,
    incompatibleCodes: state.incompatibleCodes.value,
    minorQueryPending: props.minorQueryPending,
    preferences: props.preferences,
    theme: props.theme,
    data: props.data
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(AccessoriesSelector);